import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDBodyText } from '@facet-wealth/design';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['goalAmount', 'goalDate'], {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'sm' },
  }, overrideReadOnly);
